<div class="widget-mia">
  <!-- carregando -->
  <div class="widget-mia__estado" *ngIf="carregando">
    <div class="widget-mia__spinner"></div>
  </div>

  <!-- link inválido / desativado -->
  <div class="widget-mia__estado" *ngIf="invalido">
    <div class="widget-mia__estado-icone">🔗</div>
    <h2>Link indisponível</h2>
    <p>Este link de demonstração não está mais ativo.<br>Fale com quem te enviou para receber um novo.</p>
  </div>

  <!-- demo -->
  <ng-container *ngIf="info && backend">
    <header class="widget-mia__topo">
      <img class="widget-mia__logo" *ngIf="info.logo" [src]="info.logo" [alt]="info.nome"/>
      <div class="widget-mia__titulos">
        <strong>{{ info.nomeBot }}</strong>
        <small>{{ info.nome }} · demonstração</small>
      </div>
      <button class="widget-mia__nova" (click)="novaConversa()" title="Começar de novo">
        <i class="fas fa-redo-alt"></i>
      </button>
    </header>

    <main class="widget-mia__chat">
      <app-tela-teste-mia-v3 modo="widget" [backend]="backend"></app-tela-teste-mia-v3>
    </main>
  </ng-container>
</div>
